import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IProjectConfigBodyDataInput } from '../../../interface/interfaces';

interface IInitialState {
    projectFeaturePostListLoading: boolean;
    projectFeaturePostListData: string;
    projectFeaturePostListError: string;
}

const initialState: IInitialState = {
    projectFeaturePostListLoading: false,
    projectFeaturePostListData: '',
    projectFeaturePostListError: '',
};

const projectFeatureListPostSlice = createSlice({
    name: 'projectFeatureListPost',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        projectFeatureListPostPending: (state: IInitialState, action: PayloadAction<IProjectConfigBodyDataInput>) => {
            state.projectFeaturePostListLoading = true;
            state.projectFeaturePostListError = '';
        },

        projectFeatureListPostFulfilled: (state: IInitialState, action: PayloadAction<string>) => {
            state.projectFeaturePostListLoading = false;
            state.projectFeaturePostListData = action.payload;
            state.projectFeaturePostListError = '';
        },

        projectFeatureListPostFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.projectFeaturePostListLoading = false;
            state.projectFeaturePostListData = '';
            state.projectFeaturePostListError = action.payload;
        },
    },
});

export default projectFeatureListPostSlice.reducer;
export const { projectFeatureListPostPending, projectFeatureListPostFulfilled, projectFeatureListPostFailure } = projectFeatureListPostSlice.actions;
